((($) => {
	'use strict';

    // Make slides the same height
    if (Drupal) {
        // Drupal will call attach() for all behaviors after the page is loaded.
        Drupal.behaviors.equalizeHeightOfHeroSlides = {
            attach: function (context, settings) {
                $('#hero-banner').eqHeight('.page-header');
            }
        };
    }
})(jQuery));
